import { useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { TextInput } from '~/eds/src/components/TextInput/TextInput';
import { Input } from '~/eds/src/types/Input';

import { isValidTime } from './utils';

export const DateTimeInput = ({
  name,
  value,
  disabled,
  width,
  onChange,
}: Input<string>) => {
  const intl = useIntl();

  const error = isValidTime(value)
    ? ''
    : intl.formatMessage({
        id: 'DateTimeInput.invalidTimeError',
        defaultMessage: 'Invalid time (HH:MM)',
        description: 'Error message for invalid time format input',
      });

  return (
    <Layout direction="column">
      <TextInput
        name={name}
        value={value}
        onChange={onChange}
        width={width}
        error={error}
        disabled={disabled}
      />
      <Box minH={20}>
        <Text variant="tiny" color="status.danger" role="note">
          {error}
        </Text>
      </Box>
    </Layout>
  );
};
